export const languages = {
  default: 'english',
  pt: 'portuguesa',
  zh: 'china',
}
